import { Http } from '@/model/Http.js'

export default class order extends Http {
  //推广订单
  getOrderList(data){
    const url = 'api/open/order/search'
    return this.postAjaxByKfc(url, {
       ...data
    })
  }

 //订单详情
  getOrderInfo(data){
    const url='api/open/order/query'
    return this.postAjaxByKfc(url, {
      ...data
    })
  }


  //导出订单
  exportOrder(data){
    const url='api/open/order/export'
    return this.postAjaxByKfcExport(url, {
      ...data
    })
  }
}



// WEBPACK FOOTER //
// ./src/javaApi/kfc/order.js